var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-container',{attrs:{"fluid":""}},[_c('customer-form',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }